import { useState } from 'react';
import { useDispatch,useSelector } from 'react-redux';
import { Link,useLocation  } from 'react-router-dom';

import { visualizerActions, uiActions } from '../../store';

import { ChamUploadButton } from '../ChamUpload/ChamUpload';
import PrintLink from '../PrintLink/PrintLink';
import { saveProject } from "../../Helpers/ProjectsHelper";

import styles from './TopMenu.module.css';

import logo from './assets/logo.png';
import closeIcon from './assets/close.svg';
import openIcon from './assets/open.svg';
import { useNavigate } from 'react-router-dom';

export default function TopMenu({ extended,page }) {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const compareData = useSelector(state => state.visualizer.compareData);
    const appliedProducts = useSelector(s => s.visualizer.appliedProducts);
    const submenu = useSelector(s => s.visualizer.activeFlooringSubMenuTab);
    const activeFlooringSeriesIds = useSelector(s => s.visualizer.activeFlooringSeriesIds);
    const specifier = useSelector(s => s.visualizer.specifier);
    const activeSurface = useSelector(s => s.visualizer.activeSurface);
    const masterData = useSelector(s => s.visualizer.productDataBySeries) || {};
    const location = useLocation();
    
 
    // Holds the mobile menu open/closed status
    const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

    const handleStartOver = () => {
        document.getElementById('chamVizSub').style.visibility = 'hidden';
        dispatch(visualizerActions.setCompareData({ key: 'active', value: false }));
        navigate('/');
    };

    // Update mobile menu status on the hamburger icon click
    const handleMenuTriggerClick = function () {
        setIsMobileMenuOpen(status => !status);
    }

    const handleShareModalButtonClick = function () {
        dispatch(uiActions.setShareModalActive(true));
    }
    const handleHelpModalButtonClick = function () {
        dispatch(uiActions.setHelpModalActive(true));
    }

    const handleFeedbackModalButtonClick = function () {
        dispatch(uiActions.setFeedbackModalActive(true));
    }


    const handleProjectSave = function () {

        const payload = saveProject({
            
            specifier,
            appliedProducts,
            locationSearch: location.search,
            appliedKey: 'chamViz',
            activeFlooringSeriesIds,
            submenu
            
      });
    }

    const handleProjectsOpen = function () {

        dispatch(uiActions.setProjectsModalActive(true));
    }

    const handleDownload10x10 = async function () {
        // Get the applied flooring product
        const floorProduct = appliedProducts?.chamViz?.Floor;
        
        if (!floorProduct || !floorProduct.colorway) {
            alert('Please select a flooring product first');
            return;
        }

        const productName = floorProduct.colorway.name || 'flooring-product';
        const installId = floorProduct.install || 5983716; // default install ID
        
        // Get install name from masterData only for Modular Carpet
        let installName = '';
        if (submenu === 'Modular Carpet') {
            const installData = masterData['8642'] || {};
            const installEntry = Object.values(installData).find(obj => obj.id === installId);
            installName = installEntry?.name ? `_${installEntry.name.replace(/[^a-z0-9]/gi, '_')}` : '';
        }

        // Show loading modal
        dispatch(uiActions.setDownloadModalActive(true));

        try {
            const imageUrl = `https://renderfarm1.chameleonpower.com/cham/getImage.ashx?spec=Mannington\\Images\\Swatch&sel=${installId}(${floorProduct.colorway.id},{90})&size=4000`;
            console.log('imageUrl',imageUrl)
            const response = await fetch(imageUrl);
            const blob = await response.blob();
            
            // Create download link
            const url = window.URL.createObjectURL(blob);
            const link = document.createElement('a');
            link.href = url;
            link.download = `${productName.replace(/[^a-z0-9]/gi, '_')}${installName}.jpg`;
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            window.URL.revokeObjectURL(url);
        } catch (error) {
            console.error('Download failed:', error);
            alert('Failed to download image. Please try again.');
        } finally {
            dispatch(uiActions.setDownloadModalActive(false));
            dispatch(uiActions.setPopUpModalActive(false)); // remove blur overlay
        }
    }

    const handleDownloadRoomView = async function () {
        const chamviz = document.getElementById('chamViz');
        if (!chamviz || typeof chamviz.getSaveData !== 'function') {
            alert("The visualizer isn't ready yet. Try again in a moment.");
            return;
        }

        const saveData = chamviz.getSaveData();

        if (!appliedProducts || Object.keys(appliedProducts).length === 0) {
            alert("Please select at least 1 product.");
            return;
        }

        // Get the applied flooring product for filename
        const floorProduct = appliedProducts?.chamViz?.Floor;
        const productName = floorProduct?.colorway?.name || 'room-view';
        const installId = floorProduct?.install || 5983716; // default install ID
        
        // Get install name from masterData only for Modular Carpet
        let installName = '';
        if (submenu === 'Modular Carpet') {
            const installData = masterData['8642'] || {};
            const installEntry = Object.values(installData).find(obj => obj.id === installId);
            installName = installEntry?.name ? `_${installEntry.name.replace(/[^a-z0-9]/gi, '_')}` : '';
        }

        // Show loading modal
        dispatch(uiActions.setDownloadModalActive(true));

        try {
            const imageUrl = `https://renderfarm1.chameleonpower.com/cham/GetImage.ashx?spec=${encodeURIComponent(saveData.specifier)}&sel=${encodeURIComponent(saveData.sel)}&Size=2048&type=base`;
            console.log('Room view imageUrl', imageUrl);
            
            const response = await fetch(imageUrl);
            const blob = await response.blob();
            
            // Create download link
            const url = window.URL.createObjectURL(blob);
            const link = document.createElement('a');
            link.href = url;
            link.download = `${productName.replace(/[^a-z0-9]/gi, '_')}${installName}_room_view.jpg`;
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            window.URL.revokeObjectURL(url);
        } catch (error) {
            console.error('Download failed:', error);
            alert('Failed to download image. Please try again.');
        } finally {
            dispatch(uiActions.setDownloadModalActive(false));
            dispatch(uiActions.setPopUpModalActive(false)); // remove blur overlay
        }
    }


    return (
        // <section style={{ display: 'none' }} className={styles.topMenu}>
         <section className={styles.topMenu}>
            <nav aria-label="Main Navigation">
                <ul className={!isMobileMenuOpen ? styles.closed : ''}>
                    {/* <li className={styles.logo}>
                        <Link to="/" aria-label="Home">
                            <img src={logo} alt="Company Logo" />
                        </Link>
                    </li> */}

                    <li className={styles.menuTrigger}>
                        <button onClick={handleMenuTriggerClick} aria-expanded={isMobileMenuOpen} aria-controls="main-menu">
                            <span aria-hidden="true">
                                {!isMobileMenuOpen && <img src={openIcon} alt='open icon' />}
                                {isMobileMenuOpen && <img src={closeIcon} alt='close icon' />}
                            </span>
                        </button>
                    </li>

                    {page !== 'landing' && (
                        <>
                            {/* <li>
                                <button type="button" onClick={handleStartOver} className="link-style">
                                    Start Over
                                </button>
                            </li> */}
                            
                        {extended && (<li><Link to="/roomscenes" aria-label="New scene Button">New Scene</Link></li> )}
                            {/* <li>
                                <ChamUploadButton title="Upload Photo" className="" aria-label="Upload Button" />
                            </li> */}

                                   
                        </>
                    )}

                        {1==1 && (
                            <>
                                <li>
                                    <PrintLink />
                                </li>

                                <li>
                                    <button type="button" onClick={handleShareModalButtonClick} aria-label="Share">
                                        <span>Share Link</span>
                                    </button>
                                </li>

                            </>
                        )}

                   
                    {extended && (
                        <>
                            <li>
                                <button type="button" onClick={handleDownload10x10} aria-label="Download 10x10">
                                    <span>Download 10 x 10</span>
                                </button>
                            </li>
                            <li>
                                <button type="button" onClick={handleDownloadRoomView} aria-label="Download Room View">
                                    <span>Download Room View</span>
                                </button>
                            </li>
                            <li>
                                <button type="button" onClick={handleProjectSave} aria-label="Projects">
                                    <span>Save Project</span>
                                </button>
                            </li>
                        </>
                    )}
                    {/* <li>
                        <button type="button" onClick={handleProjectsOpen} aria-label="Projects">
                            <span>My Projects</span>
                        </button>
                    </li> */}
                    
                    {extended && (<>
                        

                        


                        <li>
                            <button type="button" onClick={handleFeedbackModalButtonClick} aria-label="Feedback">
                                <span>Feedback</span>
                            </button>
                        </li>

            

                        {page === 'landing' && (
                            <li>
                                <Link to="/roomscenes" aria-label="Get started button">Get Started</Link>
                            </li>
                        )}
                        {/* <li className={styles.quote}>
                            <button type="button" onClick={() => window.open('https://www.southernluxeflooring.com/start-your-project', '_blank')} aria-label="Request a Quote">
                                <span>Request a Quote</span>
                            </button>
                        </li> */}

<li>
                            <button type="button" onClick={handleHelpModalButtonClick} aria-label="Share">
                                <span>Help</span>
                            </button>
                        </li>

                    </>
                    

                    )}


                </ul>
            </nav>
        </section>
    );
}

